import { Context } from '@nuxt/types';

export default async ({ store }: Context) => {
  await store.dispatch('auth/handleExpiredLocalStorage');
};
